<template>
  <!-- eslint-disable -->
  <div class="container-fluid">
    <div class="row header">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <p class="dg-header-label">utilities</p>
        <h1 class="dg-header">Float</h1>
        <p>Toggle floats on any element, across any breakpoint, using our responsive float utilities.</p>
      </div>
    </div>

    <div class="row content">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <!-- Content -->
        <div class="row">
          <div class="col">
            <p class="h3 dg-subheader">A few Examples</p>
            <div class="float-left p-2 bg-light">Float left on all viewport sizes</div><br>
            <div class="float-right p-2 bg-light">Float right on all viewport sizes</div><br><br>
            <div class="float-none p-2 bg-light">Don't float on all viewport sizes</div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">
            <p class="h3 dg-subheader">Code</p>
            <pre class="code-sample">
              <code class="html">
&lt;div class="float-left"&gt; ... &lt;/div&gt;
&lt;div class="float-right"&gt; ... &lt;/div&gt;
&lt;div class="float-none"&gt; ... &lt;/div&gt;</code>
            </pre>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">
            <p class="h3 dg-subheader">Variants / Modifiers</p>
            <p>These utility classes float an element to the left or right, or disable floating, based on the current viewport size using the <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/float" target="_blank">CSS float property</a>. <span class="code">!important</span> is included to avoid specificity issues. These use the same viewport breakpoints as our grid system.</p>
            <p>Responsive variations also exist for each <span class="code">float</span> value.</p>
            <p>Here are all the support classes:</p>
            <ul>
              <li class="var-sample mb-2">.float-left</li>
              <li class="var-sample mb-2">.float-right</li>
              <li class="var-sample mb-2">.float-none</li>
              <li class="var-sample mb-2">.float-sm-left</li>
              <li class="var-sample mb-2">.float-sm-right</li>
              <li class="var-sample mb-2">.float-sm-none</li>
              <li class="var-sample mb-2">.float-md-left</li>
              <li class="var-sample mb-2">.float-md-right</li>
              <li class="var-sample mb-2">.float-md-none</li>
              <li class="var-sample mb-2">.float-lg-left</li>
              <li class="var-sample mb-2">.float-lg-right</li>
              <li class="var-sample mb-2">.float-lg-none</li>
              <li class="var-sample mb-2">.float-xl-left</li>
              <li class="var-sample mb-2">.float-xl-right</li>
              <li class="var-sample mb-2">.float-xl-none</li>
            </ul>
          </div>
        </div>
       <!--  <div class="row mt-4">
          <div class="col">
            <p class="h4 dg-subheader">Accessibility</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi ad doloremque rem quasi voluptatum temporibus voluptates non unde, veritatis molestias velit impedit iste tenetur officiis et quae nisi facilis atque!</p>
          </div>
        </div> -->
        <!-- Content End -->
      </div>
    </div>  
  </div>
  <!-- eslint-enable -->
</template>

<script>
export default {
  name: "Float"
};
</script>

/* esling-disable */
<style lang="sass?outputStyle=expanded">
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/routes/Float.vue